//Please use this service only if there's a UTMOST need to share data among checkout components
//instead of creating a separate variable, getter & setter use this.
export enum CheckoutStateSharedKeys {
  OrderHasAlcohol = 'ORDER_HAS_ALCOHOL',
  RatepayDeviceFingerPrint = 'RATEPAY_DEVICE_FINGER_PRINT',
  FFCheckoutBackBtnToggle = 'FF_CHECKOUT_TOGGLE_BACK_BUTTON',
  HandlePaymentProcessingCb = 'HandlePaymentProcessingCb',
  CCSavePaymentMethod = 'CCSavePaymentMethod',
  PaymentMethodStateCC = 'PaymentMethodStateCC',
  CreditCardTokenInputEnabled = 'CreditCardTokenInputEnabled',
  CreditCardInputLast4Digit = 'CreditCardInputLast4Digit',
  FFRatePayMobileNumber = 'FFRatePayMobileNumber'
}

export class CheckoutStateSharedService {
  private static dataMap: Map<CheckoutStateSharedKeys, any> = new Map();
  
  public static get<T>(key: CheckoutStateSharedKeys): T | null {
    return this.dataMap.get(key) ?? null;
  }

  public static set(key: CheckoutStateSharedKeys, data: any): void {
    this.dataMap.set(key, data);
  }

  public static delete(key: CheckoutStateSharedKeys): void{
    this.dataMap.delete(key);
  }
}
